export default {
  title: {
    name: "美信小程序"
  },
  mxTitle: '美信',
  mxLongContent: '美信与你一起成长',
  locale: '中文',
  help: '帮助与反馈',
  welcome: "欢迎",
  downloadNow: '立即下载',
  netError: '网络异常,请稍后重试',
  codeLargeTip: '（移动端下载二维码可点击放大查看）',
  ok: '我知道了',
  clickRightTopIOS: '点击右上角菜单，在Safari中打开',
  clickRightTopAndroid: '点击右上角菜单，在浏览器中打开',
  mx: {
    introduce: '美信是美的集团自研的、服务于美的员工和外协员工的企业级沟通协作一体化平台，集会话沟通、视频会议、共享文档、小程序、资讯互动等服务于一体，助力于员工之间的高效沟通和协作。',
    downTips: '下载美信客户端',
    ios: 'iOS',
    android: 'Android & 鸿蒙',
    mac: 'macOS',
    window: 'Windows',
    downloadClick: '点击立即下载',
    downloadScan: '扫码立即下载',
    scanCodeDown: '扫描二维码下载手机客户端'
  },
  vpn: {
    title: '美的VPN',
    introduce: 'VPN是美的集团内部使用的网络工具，可以协助员工在居家、出差等场景下进行远程办公，提高工作效率。',
    tips: '长按保存至相册或识别二维码进行下载',
    downTips: '下载VPN',
    configureSeq: '安装指引',
    configureDownload: '配置文件',
    pcCoreAliens: '切换为中国境外版',
    pcCoreZH: '切换为中国境内版',
    iphoneCoreAliens: '海外客户端下载',
    iphoneCoreZH: '内地客户端下载',
    downloadAliens: '扫码立即下载',
    downloadZH: '扫码立即下载',
  },
  MacDownload: {
    title: '下载更适合你 Mac 的美信版本',
    text1: '美信针对采用Intel芯片的Mac电脑和采用Apple芯片的Mac电脑都进行了优化，使用正确的版本有助于降低资源消耗，提升软件性能。',
    text2: '如何确定你的Mac电脑芯片类型?',
    text3: '',
    text4: '*如果你无法确认芯片版本，可直接下载intel版',
    macIntel: '下载Intel芯片版本',
    macM1: '下载Apple芯片版本',
    aboutLeft: '1. 点击左上角苹果菜单，选择 ',
    about: '关于本机',
    aboutRight: '',
    gaishuLeft: '2. 在 ',
    gaishu: '概览',
    chuliqiLeft: '页面的',
    chuliqi: '处理器',
    typeLeft: ' 一栏，查看',
    type: '芯片类型',
    intelLeft: ' 是"',
    intel: 'Intel（英特尔）',
    appleLeft: '"还是"',
    apple: 'Apple',
    appleRight: '"，并选择下载对应版本',
    img1: require('../assets/M1/img1_cn.png'),
    img2: require('../assets/M1/img2_cn.png'),
    img3: require('../assets/M1/img3_cn.png'),
  }
}